export default "__VITE_ASSET__CVwVV5V$__"